import { defineMessages } from 'react-intl';

export const ContentSensorNotFound = defineMessages({
  text: {
    id: 'app.CounterSensorNotFound.text',
    defaultMessage: 'Senzor nebyl nalezen v ČRA databázi a není možné ho registrovat',
  },
});

export const ContentSensorNotResponding = defineMessages({
  success: {
    id: 'app.CounterSensorNotResponding.success',
    defaultMessage: 'Senzor byl nalezen v ČRA databázi',
  },
  warning: {
    id: 'app.CounterSensorNotResponding.warning',
    defaultMessage: 'Nebyly nalezeny žádné zprávy ze senzoru v posledních {days} dnech!',
  },
});

export const ContentSensorRegistration = defineMessages({
  success: {
    id: 'app.CounterSensorRegistration.success',
    defaultMessage: 'Senzor byl úspěšně registrován',
  },
  error: {
    id: 'app.CounterSensorRegistration.error',
    defaultMessage: 'Chyba při registraci senzoru',
  },
  sensorNotFound: {
    id: 'app.CounterSensorNotFound.text',
    defaultMessage: 'Senzor nebyl nalezen v ČRA databázi a není možné ho registrovat',
  },
  sensorSuccess: {
    id: 'app.CounterSensorRegistration.sensorSuccess',
    defaultMessage: 'O senzoru máme informace, může být registrován',
  },
  registerSensor: {
    id: 'app.CounterSensorRegistration.registerSensor',
    defaultMessage: 'Zaregistrovat senzor',
  },
});

export const ContentSensorSuccess = defineMessages({
  dateAndTime: {
    id: 'app.common.dateAndTime',
    defaultMessage: 'Datum a čas',
  },
  sensorRegistered: {
    id: 'app.ContentSensorSuccess.sensorRegistered',
    defaultMessage: 'Senzor je zaregistrován do sítě ČRA',
  },
  sensorSendsMessages: {
    id: 'app.ContentSensorSuccess.sensorSendsMessages',
    defaultMessage: 'Senzor posílá zprávy',
  },
});

export const SensorConnectionStepFooter = defineMessages({
  missingSensor: {
    id: 'app.SensorConnectionStepFooter.missingSensor',
    defaultMessage: 'Senzor chybí v ČRA',
  },
  sensorNotRegistered: {
    id: 'app.SensorConnectionStepFooter.sensorNotRegistered',
    defaultMessage:
      'Senzor není registrován v síti a nebude posílat zprávy dokud se do sítě dodatečně nezaregistruje opravdu chcete pokračovat?',
  },
  cancel: {
    id: 'app.common.cancel',
    defaultMessage: 'Zrušit',
  },
  continue: {
    id: 'app.common.continue',
    defaultMessage: 'Pokračovat',
  },
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
});
